import request from '../request'
import axios from 'axios'
/** 
 * 用户管理接口，包括用户列表查询、增加、停用、重置密码，以及用户密码的修改
*/
export function fetchList(params) {
    return request({
        url: '/basic-service/user/list',
        params
    })
}

export function add(data) {
    return request({
        url: '/basic-service/user/add',
        method: 'POST',
        data,
    })
}

export function fetchDetail(params) {
    return request({
        url: '/basic-service/user/query',
        params
    })
}

export function edit(data) {
    return request({
        url: '/basic-service/user/update',
        method: 'POST',
        data,
    })
}

export function editBaseInfo(data) {
    return request({
        url: '/basic-service/user/updateBase',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/basic-service/user/delete',
        method: 'POST',
        data
    })
}

// 获取用户数据权限
export function fetchDataPermission(params) {
    return request({
        url: '/common-service/userDataPermission/query',
        params
    })
}

// 配置用户权限
export function configDataPermission(data) {
    return request({
        url: '/common-service/userDataPermission/config',
        method: 'POST',
        data
    })
}

// 查询某一个用户的详细信息，包括跟员工相关的
export function fetchUserEmployeeDetail(params) {
    return request({
        url: `/user-service/employee/query/${params.userId}`,
    })
}

// 重置密码为默认Zaoyang@2024
export function resetUserPassword(params) {
    return request({
        url: '/basic-service/user/resetpassword',
        method: 'POST',
        params: {
            id: params.id
        }
    })
}

// 用户修改密码
export function changeUserPassword(params) {
    return request({
        url: '/basic-service/user/updateBase',
        method: 'POST',
        data: params
    })
}

export function confirmOldPassword(data) {
    /** 这个代码用直接请求，不走request代理，这样失败了不会报错 */
    return axios.request({
        url: 'http://223.75.200.168:38400/api/basic-service/auth/login',
        method: 'post',
        data
    })
}